export default __webpack_public_path__ + "static/22-6051fe097b6f9ceabbde50cabcedaed9.webp";